import { enterSpace } from '../../app/actions/spaces/EnterSpaceAction';
import { requestSpaceContents } from '../../app/actions/spaces/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '../../app/actions/UpdateBreadcrumbsAction';
import { appStore } from '../../app/AppStore';
import { addUrlWatchersToScopeForExplorer } from '../../app/spaces/Explorer/ExplorerUrlBindings';
import { RecommendationsSpaceOwnProps } from '../../app/spaces/RecommendationSpace/RecommendationsSpace';
import { setURLParametersOrDefaultsForEnteringSpaceAndFetchContent } from '../../app/spaces/SpaceConfig/SiteSpaceConfigHelper';
import { SpaceItemForNonEntitySpace } from '../../app/state/SpaceInfo';
import { Messages } from '../../codegen/Localize';
import { getQueryStringServiceFromAngular } from '../../common/react/QueryString';
import { AngularContextFactory } from '../factories/AngularContextFactory';
import { Module } from '../Module';
import { BrowserTitleService } from '../services/BrowserTitleService';
import { Telemetry } from '../services/TelemetryService';

export interface IRecommendationsSpaceScope extends ng.IScope {
  recommendationsSpaceProps: RecommendationsSpaceOwnProps;
}

export class RecommendationsSpaceCtrl {

  private currentPath: string;

  public static $inject = [
    '$location',
    '$scope',
    'BrowserTitleService',
    'TelemetryService',
    'AngularContextFactory',
  ];

  constructor(
    $location: ng.ILocationService,
    $scope: IRecommendationsSpaceScope,
    browserTitleService: BrowserTitleService,
    telemetryService: Telemetry,
    angularContextFactory: AngularContextFactory,
  ) {
    browserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.vizRecommendationsTitle() });

    const angularContext = angularContextFactory.create($scope);
    $scope.recommendationsSpaceProps = {
      telemetry: telemetryService,
      angularContext
    };

    // Must be done before any of the setting of sorts and defaults below
    appStore.dispatch(enterSpace({
      item: SpaceItemForNonEntitySpace,
      spaceType: 'recommendations',
      subspaceName: undefined
    }));

    appStore.dispatch(updateBreadcrumbs([]));

    const queryString = getQueryStringServiceFromAngular($location);
    this.currentPath = $location.path();
    const getPath = () => {
      return this.currentPath;
    };

    // need to reset all filters and sorts when entering the recommendation space
    setURLParametersOrDefaultsForEnteringSpaceAndFetchContent(appStore, $location);
    addUrlWatchersToScopeForExplorer({ $scope, $location, queryString, store: appStore, getPreviousPath: getPath });

    appStore.dispatch(requestSpaceContents());
  }
}

Module.instance().controller('RecommendationsSpaceCtrl', RecommendationsSpaceCtrl);
